import * as THREE from "three";

// new PresetLight();
// const PRESET_LIGHTS = {};

export default class LightGenerator {
  static create({ x, y, z }, intensity = 1) {
    const color = 0xfffffff;
    const light = new THREE.DirectionalLight(color, intensity);
    light.position.set(x, y, z);
    return light;
  }
}
